module.exports = __webpack_public_path__ + "static/media/impact-volunteering.4cbc82a1.md";